// Latest-Kacheln: Datum oben rechts auf dem Foto; der große Hero-Beitrag (HeroFeature) zeigt es über dem weissen Kasten.
import { Link } from "@tanstack/react-router";

import { DateBlock } from "@/components/site/DateBlock";
import { LazyEventCardActions } from "@/components/site/LazyEventCardActions";
import type { Meeting } from "@/lib/content";
import { meetingDateParts, meetingLocationLabel } from "@/lib/meeting-format";
import featuredFallback from "@/assets/featured-1280.webp.asset.json";
import { PHOTO_CARD_SIZES } from "@/lib/cover-image";

const FALLBACK_IMAGE = featuredFallback.url;

export function PhotoCard({ meeting }: { meeting: Meeting }) {
  const image = meeting.cover_image_url ?? FALLBACK_IMAGE;
  const parts = meetingDateParts(meeting);
  const location = meetingLocationLabel(meeting);
  const isUpcoming = meeting.is_upcoming || meeting.category === "Upcoming";

  return (
    <div className="relative">
    <Link
      to="/meetings/$slug"
      params={{ slug: meeting.slug }}
      className="group block"
    >
      <div className="relative">
        <img
          src={image}
          srcSet={meeting.cover_image_srcset}
          sizes={PHOTO_CARD_SIZES}
          width={640}
          height={367}
          alt={meeting.title}
          loading="lazy"
          decoding="async"
          className="h-[220px] w-full object-cover"
        />
        {parts && (
          <div className="absolute right-0 top-0">
            <DateBlock parts={parts} tone={isUpcoming ? "accent" : "light"} />
          </div>
        )}
      </div>
      <div className="relative -mt-8 mx-4 h-[172px] bg-card px-5 py-4 shadow-[4px_4px_0px_0px_oklch(0.35_0_0)]">
        {location && <p className="fc-meta line-clamp-1 text-accent">{location}</p>}
        <h3
          className={`fc-h4 line-clamp-3 min-h-[78px] text-foreground group-hover:text-accent min-[640px]:min-h-[75px] ${
            location ? "mt-1" : ""
          }`}
        >
          {meeting.title}
        </h3>
      </div>
    </Link>
    <LazyEventCardActions slug={meeting.slug} title={meeting.title} photo />
    </div>
  );
}
